import axios from 'axios';
import cx from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Announcement, Button, CardAction, Navbar, ShortDesc, Sidebar, Spacer, WhaleTransaction } from '../../components';
import URL from "../../config/api.json";
import { networks } from '../../services';
import './Whale.scss';
function Whale() {
  const [closeSide, setCloseSide] = useState(false)
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }

  const [network, setNetwork] = useState([])
  const [watchlist, setWatchlist] = useState([])
  const [inputWa, setInputWa] = useState('')
  const [inputNet, setInputNet] = useState('')
  const [analyze, setAnalyze] = useState([])
  const [loading, setLoading] = useState(false)
  const [ann, setAnn] = useState(true)
  const netWorkList = useCallback(
    async () => {
      const data = await networks()
      setNetwork(data)
    },
    [],
  )
  // const watchlistData = useCallback(
  //   async () => {
  //     const data = await watchLists()
  //     setWatchlist(data)
  //   },
  //   [],
  // )

  // GET WATCHLIST LOCAL
  const getWatchListLocal = async () => {
    if (localStorage.whale_watchlist) {
      const data = await JSON.parse(localStorage.whale_watchlist)
      setWatchlist(data)
    }
  }
  useEffect(() => {
    netWorkList()
    // watchlistData()
    getWatchListLocal()
  }, [netWorkList])

  // netWorkList, watchlistData, watchlist

  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  // ONLINE WATCHLIST
  // const subMitWatchlist = async () => {
  //   const data = {
  //     address: inputNet,
  //     network: inputWa
  //   }
  //   if (!data.address || !data.network) {
  //     toast.error("Please fill address and network!")
  //   } else {
  //     const result = await postWatchlist(data)
  //     if (result.status === 1) {
  //       toast.success("Success add watchlist")
  //       watchlistData()
  //     } else {
  //       toast.error("Failed add watchlist")
  //       setInputNet('')
  //       setInputWa('')
  //     }
  //   }
  // }

  // OFLINE WATCHLIST
  const subMitWatchlist = async () => {
    const data = {
      address: inputNet,
      network: inputWa
    }
    if (!data.address || !data.network) {
      toast.error("Please fill address and network!")
    } else {
      if (localStorage.whale_watchlist) {
        const lists = JSON.parse(localStorage.whale_watchlist);
        lists.push(data);
        localStorage.setItem('whale_watchlist', JSON.stringify(lists));
        getWatchListLocal()
        setInputNet('')
      } else {
        localStorage.setItem('whale_watchlist', JSON.stringify([data]));
        getWatchListLocal()
        setInputNet('')
      }
    }
  }
  // OFFLINE UPDATE WATHLIST
  const updateLocalWatchlist = (data) => {
    if (localStorage.whale_watchlist) {
      const localWL = JSON.parse(localStorage.whale_watchlist)
      const newData = [];
      localWL.filter(item => {
        if(item.address !== data.address || item.network !== data.network){
          newData.push(item);
        }
        localStorage.setItem('whale_watchlist', JSON.stringify(newData));
        getWatchListLocal()
      })
    }
  }
  const retriveLocalWatchlist = (data)=>{
   setInputNet(data.address)
   setInputWa(data.network)
  }


  const getWhalesHistory = async (days) => {
    if(!inputNet || !inputWa) return toast.warning("Fill whale address and select network please!")
    setLoading(true)
    const result = await axios.get(`${URL.API_URL}whales/analyze?address=${inputNet}&network=${inputWa}&days=${days}`)
    setInputNet('')
    setInputWa('')
    setAnalyze(result.data.data)
    setLoading(false)
  }


  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            
            {
              ann && <Announcement
              message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
              onClick={()=>setAnn(false)}
              varian="dark"
               />
            }
            <CardAction />
            <div className="row">
              <div className="col-xl-8">
                <Spacer h={20} />
                <div className="cardContainer">
                  <ShortDesc
                  desc="Net transfer shows net balance within period of time. Positive value means the wallet owner is accumulating while negative value means distributing." />
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="formGroup">
                    <div className="mb-3 row">
                      <div className="col-sm-8 mb-2">
                        <input type="text" onChange={(e) => setInputNet(e.target.value)} value={inputNet} className="form-control form-control-lg custom-input" id="whale-address" placeholder="Whale Address" />
                      </div>
                      <div className="col-sm-4 mb-2">
                        <select onChange={(e) => setInputWa(e.target.value)} className="form-select form-select-lg custom-input">
                          <option value="">Network</option>
                          {
                            network.map(nt => {
                              return (
                                <option key={nt.id} value={nt.name}>{nt.name}</option>
                              )
                            })
                          }
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <Button onClick={subMitWatchlist} label="Add To Watchlist" varian="orange light ms-auto" width={200} />
                      </div>
                    </div>
                  </div>
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="cardUtil">
                    <div className="latsTransPageSet d-flex flex-wrap justify-content-between">
                      <button className="mb-2">Retreive last transaction</button>
                      <div className="d-flex flex-wrap">
                        <Button onClick={() => getWhalesHistory(30)} label="30 Days" varian="orange light me-2 mb-2" width={110} />
                        <Button onClick={() => getWhalesHistory(60)} label="60 Days" varian="orange light me-2 mb-2" width={110} />
                        <Button onClick={() => getWhalesHistory(90)} label="90 Days" varian="orange light me-2 mb-2" width={110} />
                        <Button onClick={() => getWhalesHistory(180)} label="180 Days" varian="orange light me-2 mb-2" width={110} />
                      </div>
                    </div>
                  </div>
                  <Spacer h={30} />
                  <WhaleTransaction analyze={analyze} loading={loading} />
                </div>
              </div>
              <div className="col-xl-4">
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="cardUtil">
                    <span className="titleCard d-block">Whale Watchlist</span>
                  </div>
                  <div className="table-responsive tableScroll scrollCustom" style={{ height: 400 }}>
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th></th>
                          <th>No</th>
                          <th>Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          watchlist.map((item, key) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <span style={{ cursor: 'pointer' }} onClick={() => updateLocalWatchlist(item)} className="text-danger">
                                    x
                                  </span>
                                </td>
                                <td>{key + 1}</td>
                                <td onClick={() => retriveLocalWatchlist(item)} style={{ cursor:'pointer' }}>{item.address}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                  <ToastContainer />
                </div>
              </div>
            </div>
            <Spacer h={20} />
           
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}
export default Whale
